import {TEMAS, type Tema} from '@cnc/contracts';
import {useGuardarPreferencias} from '../api/sesion';
import {tr} from '../i18n/idioma';
import {aplicarTema, iconoDeTema, nombreDeTema} from './usar-tema';

// Botones Claro | Oscuro | Como el sistema (decision 0023). Cambia de
// inmediato y se guarda en el perfil.
export function SelectorDeTema({tema, onCambiar}: {tema: Tema; onCambiar?: (t: Tema) => void}) {
  const guardar = useGuardarPreferencias();
  const elegir = (nuevo: Tema) => {
    if (nuevo === tema) return;
    aplicarTema(nuevo);
    onCambiar?.(nuevo);
    void guardar.mutateAsync({columnas: {}, tema: nuevo}).catch(() => undefined);
  };
  return (
    <div role="group" aria-label={tr('Tema', 'Theme')} className="inline-flex rounded-md border border-linea text-sm">
      {TEMAS.map(opcion => (
        <button
          key={opcion}
          type="button"
          onClick={() => elegir(opcion)}
          aria-pressed={opcion === tema}
          className={`px-3 py-1 first:rounded-l-md last:rounded-r-md ${
            opcion === tema ? 'bg-verde-claro font-semibold text-verde-oscuro' : 'text-apagado hover:bg-papel'
          }`}
        >
          <span aria-hidden className="mr-1">
            {iconoDeTema(opcion)}
          </span>
          {nombreDeTema(opcion)}
        </button>
      ))}
    </div>
  );
}
